import { Select, SelectProps } from 'antd'
import { useState } from 'react'

import { useTreatmentServiceGetHivAnamnesisDoctorsEndpoint } from 'src/api/queries'
import { useDebounce } from 'src/hooks'
import { useLocales } from 'src/locales'

/**
 * 4. The doctor who collected and reported the data: a user of the current institution. Only the user id is
 * stored; the saved doctor is always listed, so their name shows even outside the search.
 */
export const HivDoctorSelect = (props: SelectProps<string>) => {
  const { t } = useLocales()
  const [search, setSearch] = useState<string>()
  const debouncedSearch = useDebounce(search)

  const { data, isFetching } =
    useTreatmentServiceGetHivAnamnesisDoctorsEndpoint(
      {
        searchTerm: debouncedSearch,
        ids: props.value ? [props.value] : []
      },
      [debouncedSearch, props.value],
      { staleTime: 1000 * 60 }
    )

  return (
    <Select
      allowClear
      showSearch
      filterOption={false}
      onSearch={setSearch}
      loading={isFetching}
      placeholder={t('common.select_from_list')}
      options={(data?.data ?? []).map((doctor) => ({
        value: doctor.id,
        label: doctor.fullName
      }))}
      {...props}
    />
  )
}
